import {NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {SearchComponentComponent} from './_components/header/search-component/search-component.component';
import {OrdineStatoLabelComponent} from './_components/label/ordine-stato-label/ordine-stato-label.component';
import {InstallazioneTypeLabelComponent} from './_components/label/installazione-type-label/installazione-type-label.component';
import {TracciatiTypeFieldLabelComponent} from './_components/tracciati/tracciati-type-field-label/tracciati-type-field-label.component';
import {TipoEventoLabelComponent} from './_components/label/tipo-evento-label/tipo-evento-label.component';
import {RisorsaTipoLabelComponent} from './_components/label/risorsa-tipo-label/risorsa-tipo-label.component';
import {OrdineEsolverItemComponent} from './_components/ordine-esolver-item/ordine-esolver-item.component';
import {OrdineLocalItemComponent} from './_components/ordine-local-item/ordine-local-item.component';
import {OrdiniFilterRowComponent} from './_components/ordini-filter-row/ordini-filter-row.component';
import {OrdineEsolverLaunchComponent} from './_components/ordine-esolver-launch/ordine-esolver-launch.component';
import {OrdineLocalCreateComponent} from './_components/ordine-local-create/ordine-local-create.component';
import {OrdineInfoComponent} from './_components/ordine-info/ordine-info.component';
import {OrdineSessioniComponent} from './_components/ordine-sessioni/ordine-sessioni.component';
import {OrdiniUpdateSendComponent} from './_components/ordini-update-send/ordini-update-send.component';
import {ChiudiFasiPrecedentiComponent} from './interfaccia-manuale/interfaccia-manuale-chiudi-fasi/interfaccia-manuale-chiudi-fasi.component';
import {OrdiniEsolverComponent} from './_components/ordini-esolver/ordini-esolver.component';
import {OrdiniLocaliComponent} from './_components/ordini-locali/ordini-locali.component';
import {OrdiniLocaliGroupbymanyComponent} from './_components/ordini-locali-groupbymany/ordini-locali-groupbymany.component';
import {OrdiniViewmodeSwitchComponent} from './_components/ordini-viewmode-switch/ordini-viewmode-switch.component';
import {OrdineLocalGroupItemComponent} from './_components/ordine-local-group-item/ordine-local-group-item.component';
import {OrdineLocalGroupbymanyItemComponent} from './_components/ordine-local-groupbymany-item/ordine-local-groupbymany-item.component';
import {OrdiniEsolverGroupbymanyComponent} from './_components/ordini-esolver-groupbymany/ordini-esolver-groupbymany.component';
import {OrdineEsolverGroupbymanyItemComponent} from './_components/ordine-esolver-groupbymany-item/ordine-esolver-groupbymany-item.component';
import {OrdineLocalHeaderComponent} from './_components/ordine-local-header/ordine-local-header.component';
import {OrdiniLocaliListComponent} from './_components/ordini-locali-list/ordini-locali-list.component';
import {OrdiniGroupColumnsComponent} from './_components/ordini-group-columns/ordini-group-columns.component';
import {OrdiniShowColumnsComponent} from './_components/ordini-show-columns/ordini-show-columns.component';
import {OrdiniGroupUpdateSendComponent} from './_components/ordini-group-update-send/ordini-group-update-send.component';
import {TracciatiFieldCreateComponent} from './_components/tracciati/tracciati-field-create/tracciati-field-create.component';
import {TracciatiFieldListComponent} from './_components/tracciati/tracciati-field-list/tracciati-field-list.component';
import {TracciatoFieldStatoComponent} from './_components/tracciati/tracciato-field-stato/tracciato-field-stato.component';
import {HubStateLedComponent} from './_components/header/hub-state-led/hub-state-led.component';
import {CentroNotificheComponent} from './_components/header/centro-notifiche/centro-notifiche.component';
import {CentroNotifichePopupComponent} from './_components/header/centro-notifiche-popup/centro-notifiche-popup.component';
import {OrdiniStatisticsComponent} from './_components/ordini-statistics/ordini-statistics.component';
import {QualitaStatisticsComponent} from './_components/qualita/qualita-statistics/qualita-statistics.component';
import {BarChartComponent} from './_components/charts/bar-chart/bar-chart.component';
import {PieChartComponent} from './_components/charts/pie-chart/pie-chart.component';
import {TruncatePipe} from './_helpers/TruncatePipe';
import {OrderByPipe} from './_helpers/order-by.pipe';
import {FloorPipe} from './_helpers/FloorPipe';
import {TimeStringPipe} from './_helpers/TimeStringPipe';
import {SumByPipe} from './_helpers/sum-by.pipe';
import {KeyboardComponent} from './_components/keyboard/keyboard.component';
import {LicenzeConfigComponent} from './_components/licenze/licenze-config/licenze-config.component';
import {LicenzeConfigItemComponent} from './_components/licenze/licenze-config-item/licenze-config-item.component';
import {LicenzeMenuConfigComponent} from './_components/licenze/licenze-menu-config/licenze-menu-config.component';
import {OrdiniFilterRowCodiceUnivocoComponent} from './_components/ordini-filter-row-codice-univoco/ordini-filter-row-codice-univoco.component';
import {EventiChartComponent} from './_components/charts/eventi-chart/eventi-chart.component';
import {OrdineEsolverGroupItemComponent} from './_components/ordine-esolver-group-item/ordine-esolver-group-item.component';
import {OrdineEsolverGroupLaunchComponent} from './_components/ordine-esolver-group-launch/ordine-esolver-group-launch.component';
import {UserHeaderComponent} from './_components/header/user-header/user-header.component';
import {UserInfoComponent} from './_components/header/user-info/user-info.component';
import {FiltroOrdineComponent} from './_components/filtro-ordine/filtro-ordine.component';
import {MaterialeListComponent} from './_components/materiale-list/materiale-list.component';
import {MovimentoAddComponent} from './_components/movimenti/movimento-add/movimento-add.component';
import {MovimentoTrasferimentoComponent} from './_components/movimenti/movimento-trasferimento/movimento-trasferimento.component';
import {LottoInputComponent} from './_components/input/lotto-input/lotto-input.component';
import {SchedeQualitaListComponent} from './_components/qualita/schede-qualita-list/schede-qualita-list.component';
import {ControlloQualitaItemComponent} from './_components/qualita/controllo-qualita-item/controllo-qualita-item.component';
import {CheckControlliListComponent} from './_components/qualita/check-controlli-list/check-controlli-list.component';
import {ControlliQualitaOrdineComponent} from './_components/qualita/controlli-qualita-ordine/controlli-qualita-ordine.component';
import {RouterModule} from '@angular/router';
import {BilancaInputComponent} from './_components/input/bilanca-input/bilanca-input.component';
import {QuantitaInputComponent} from './_components/input/quantita-input/quantita-input.component';
import {BoxInputComponent} from './_components/input/box-input/box-input.component';
import {MagazzinoInputComponent} from './_components/input/magazzino-input/magazzino-input.component';
import {StatiScritturaInputComponent} from './_components/input/stati-scrittura-input/stati-scrittura-input.component';
import {AnagraficaInputComponent} from './_components/input/anagrafica-input/anagrafica-input.component';
import {AnagraficaIndirizzoInputComponent} from './_components/input/anagrafica-indirizzo-input/anagrafica-indirizzo-input.component';
import {ArticoloCicloInputComponent} from './_components/input/articolo-ciclo-input/articolo-ciclo-input.component';
import {OrdineInputComponent} from './_components/input/ordine-input/ordine-input.component';
import {ArticoloSchedeTecnicheComponent} from './_components/articolo-schede-tecniche/articolo-schede-tecniche.component';
import {SpedizioniLocaliListComponent} from './_components/spedizioni/spedizioni-locali-list/spedizioni-locali-list.component';
import {SpedizioniEsolverListComponent} from './_components/spedizioni/spedizioni-esolver-list/spedizioni-esolver-list.component';
import {SpedizioneLocaleItemComponent} from './_components/spedizioni/spedizione-locale-item/spedizione-locale-item.component';
import {SpedizioneEsolverItemComponent} from './_components/spedizioni/spedizione-esolver-item/spedizione-esolver-item.component';
import {SpedizioneUpdateSendComponent} from './_components/spedizioni/spedizione-update-send/spedizione-update-send.component';
import {SpedizioneEsolverLaunchComponent} from './_components/spedizioni/spedizione-esolver-launch/spedizione-esolver-launch.component';
import {SpedizioneSpostaColloComponent} from './_components/spedizioni/spedizione-sposta-collo/spedizione-sposta-collo.component';
import {SpedizioneStatoLabelComponent} from './_components/spedizioni/spedizione-stato-label/spedizione-stato-label.component';
import {OrdineAllegatiComponent} from './_components/ordine-allegati/ordine-allegati.component';
import {SelectModule} from './select.module';
import {ArticoloInputComponent} from './_components/input/articolo-input/articolo-input.component';
import {ContenitoreTipoLabelComponent} from './_components/label/contenitore-tipo-label/contenitore-tipo-label.component';
import {CaratteristicaSchedaTecnicaComponent} from './_components/caratteristica-scheda-tecnica/caratteristica-scheda-tecnica.component';
import {UtcToLocalPipe} from './_helpers/UtcToLocalPipe';
import {HighlightPipe} from './_helpers/highlight.pipe';
import {UdmInputComponent} from './_components/input/udm-input/udm-input.component';
import {SumByLengthPipe} from './_helpers/sum-by-length.pipe';
import {ContestoLabelComponent} from './_components/label/contesto-label/contesto-label.component';
import {TracciatiFieldRegoleComponent} from './_components/tracciati/tracciati-field-regole/tracciati-field-regole.component';
import {SpedizioneInputComponent} from './_components/input/spedizione-input/spedizione-input.component';
import {DocumentoMagazzinoItemComponent} from './_components/magazzino/documento-magazzino-item/documento-magazzino-item.component';
import {ArticoloGiacenzaComponent} from './_components/giacenza/articolo-giacenza/articolo-giacenza.component';
import {ArticoloGiacenzaLottoComponent} from './_components/giacenza/articolo-giacenza-lotto/articolo-giacenza-lotto.component';
import {ArticoloGiacenzaModalComponent} from './_components/giacenza/articolo-giacenza-modal/articolo-giacenza-modal.component';
import {DocumentoMagazzinoCreateComponent} from './_components/magazzino/documento-magazzino-create/documento-magazzino-create.component';
import {DocumentoMagazzinoDetailComponent} from './_components/magazzino/documento-magazzino-detail/documento-magazzino-detail.component';
import {DocumentoMagazzinoListComponent} from './_components/magazzino/documento-magazzino-list/documento-magazzino-list.component';
import {DocumentoMagazzinoAddContenitoriComponent} from './_components/magazzino/documento-magazzino-add-contenitori/documento-magazzino-add-contenitori.component';
import {SelezionaFaseContoLavoroModalComponent} from './_components/magazzino/seleziona-fase-conto-lavoro-modal/seleziona-fase-conto-lavoro-modal.component';
import {DocumentoMagazzinoAddPrelievoComponent} from "./_components/magazzino/documento-magazzino-add-prelievo/documento-magazzino-add-prelievo.component";
import {TimePickerInputComponent} from "./_components/input/time-picker-input/time-picker-input.component";
import {MovimentiCreateComponent} from "./_components/movimenti/movimenti-create/movimenti-create.component";
import {EnumLabelPipe} from './_helpers/enum-label.pipe'
import {FileUploadComponent} from "./_components/file-upload/file-upload.component";
import {ImagePreviewComponent} from "./_components/image-preview/image-preview.component";
import {TooltipDirective} from "./_directives/tooltip/tooltip.directive";
import {OptionComboboxComponent} from "./_components/select/option-combobox/option-combobox.component";
import {MenuTriggerDirective} from './_directives/menu-trigger/menu-trigger.directive';
import {ContenitoriCreateComponent} from "./_components/movimenti/contenitori-create/contenitori-create.component";
import {UdmConverterComponent} from "./_components/movimenti/udm-converter/udm-converter.component";
import {MovimentiRettificaComponent} from "./_components/movimenti/movimenti-rettifica/movimenti-rettifica.component";
import {ContenitoreLabelComponent} from "./_components/label/contenitore-label/contenitore-label.component";
import {ArticoloVarianteInputComponent} from "./_components/input/articolo-variante-input/articolo-variante-input.component";
import {AgentReportComponent} from "./_components/agent/agent-report/agent-report.component";
import {AgentChatComponent} from "./_components/agent/agent-chat/agent-chat.component";
import {AiChatPanelComponent} from './_components/ai-chat/ai-chat-panel/ai-chat-panel.component';
import {AiChatComandiComponent} from './_components/ai-chat/ai-chat-comandi/ai-chat-comandi.component';
import {AiChatArchivioComponent} from './_components/ai-chat/ai-chat-archivio/ai-chat-archivio.component';
import {QueuePendingOverlayComponent} from './_components/feedback/queue-pending-overlay/queue-pending-overlay.component';
import {ImportModalComponent} from "./_components/import-modal/import-modal.component";
import {AnagraficaCreateComponent} from './_components/anagrafiche/anagrafica-create/anagrafica-create.component';
// Feature 120 (issue #3368): dialogo di propagazione aperto da AnagraficaCreateComponent.
import {PropagaOrdiniModalComponent} from './_components/anagrafiche/propaga-ordini-modal/propaga-ordini-modal.component';
// Feature 122 (issue #3377): dialogo di allineamento della pianifica collegata al salvataggio ordine.
import {AllineaPianificaModalComponent} from './_components/vendita/allinea-pianifica-modal/allinea-pianifica-modal.component';
import {SelectAnagraficaRegistryComponent} from './_components/input/select-anagrafica-registry/select-anagrafica-registry.component';
import {ArticoliProdottiCreateComponent} from './_components/articoli-prodotto/articoli-prodotti-create/articoli-prodotti-create.component';
// Feature 121 (issue #3372): dialogo di propagazione Articolo → Ordini Clienti.
import {PropagaOrdiniArticoloModalComponent} from './_components/articoli-prodotto/propaga-ordini-articolo-modal/propaga-ordini-articolo-modal.component';
import {SelectArticoloProdottoComponent} from './_components/input/select-articolo-prodotto/select-articolo-prodotto.component';
import {ColorHexInputComponent} from './_components/input/color-hex-input/color-hex-input.component';
import {SelectAnagraficaSedeComponent} from './_components/input/select-anagrafica-sede/select-anagrafica-sede.component';
import {OrdiniVenditaShowColumnsComponent} from './_components/ordini-vendita-show-columns/ordini-vendita-show-columns.component';
import {OrdiniVenditaGroupColumnsComponent} from './_components/ordini-vendita-group-columns/ordini-vendita-group-columns.component';
import {OrdineVenditaCreateComponent} from './vendita/ordine-vendita-create/ordine-vendita-create.component';
import {MaterialeOrdineCreateComponent} from './vendita/materiale-ordine-create/materiale-ordine-create.component';
import {SelezionaPianificaModalComponent} from './vendita/seleziona-pianifica-modal/seleziona-pianifica-modal.component';
import {OrdiniVenditaGroupbymanyComponent} from './_components/ordini-vendita-groupbymany/ordini-vendita-groupbymany.component';
import {OrdineVenditaRowComponent} from './_components/ordine-vendita-row/ordine-vendita-row.component';
import {OrdineVenditaCellsComponent} from './_components/ordine-vendita-cells/ordine-vendita-cells.component';
import {CampiUtenteFormComponent} from './_components/campi-utente-form/campi-utente-form.component';
import {CampiUtenteAccountComponent} from './_components/campi-utente-account/campi-utente-account.component';
import {BadgeEnrollComponent} from './_components/badge/badge-enroll/badge-enroll.component';
import {ScrollToTopComponent} from './_components/scroll-to-top/scroll-to-top.component';
import {PullToRefreshDirective} from './_directives/pull-to-refresh/pull-to-refresh.directive';

@NgModule({
  declarations: [
    SearchComponentComponent,
    OrdineStatoLabelComponent,
    InstallazioneTypeLabelComponent,
    TracciatiTypeFieldLabelComponent,
    TipoEventoLabelComponent,
    RisorsaTipoLabelComponent,
    OrdineEsolverItemComponent,
    OrdineEsolverGroupItemComponent,
    OrdineEsolverGroupLaunchComponent,
    OrdineLocalItemComponent,
    OrdiniFilterRowComponent,
    OrdineEsolverLaunchComponent,
    OrdineLocalCreateComponent,
    OrdineInfoComponent,
    OrdineSessioniComponent,
    OrdiniUpdateSendComponent,
    // Feature 151: elenco fasi a monte, in linea nella modale ordine e come modale nel Termina operatore.
    ChiudiFasiPrecedentiComponent,
    OrdiniEsolverComponent,
    OrdiniLocaliComponent,
    OrdiniLocaliGroupbymanyComponent,
    OrdiniViewmodeSwitchComponent,
    OrdineLocalGroupItemComponent,
    OrdineLocalGroupbymanyItemComponent,
    OrdiniEsolverGroupbymanyComponent,
    OrdineEsolverGroupbymanyItemComponent,
    OrdineLocalHeaderComponent,
    OrdiniLocaliListComponent,
    OrdiniGroupColumnsComponent,
    OrdiniShowColumnsComponent,
    OrdiniGroupUpdateSendComponent,
    TracciatiFieldCreateComponent,
    TracciatiFieldListComponent,
    TracciatiFieldRegoleComponent,
    TracciatoFieldStatoComponent,
    HubStateLedComponent,
    CentroNotificheComponent,
    CentroNotifichePopupComponent,
    OrdiniStatisticsComponent,
    QualitaStatisticsComponent,
    BarChartComponent,
    PieChartComponent,
    EventiChartComponent,
    KeyboardComponent,
    OrderByPipe,
    TruncatePipe,
    FloorPipe,
    TimeStringPipe,
    SumByPipe,
    SumByLengthPipe,
    UtcToLocalPipe,
    HighlightPipe,
    EnumLabelPipe,
    LicenzeConfigComponent,
    LicenzeConfigItemComponent,
    LicenzeMenuConfigComponent,
    OrdiniFilterRowCodiceUnivocoComponent,
    UserHeaderComponent,
    UserInfoComponent,
    FiltroOrdineComponent,
    MaterialeListComponent,
    MovimentoAddComponent,
    MovimentoTrasferimentoComponent,
    MovimentiCreateComponent,
    ContenitoriCreateComponent,
    SchedeQualitaListComponent,
    ControlloQualitaItemComponent,
    CheckControlliListComponent,
    ControlliQualitaOrdineComponent,
    LottoInputComponent,
    OptionComboboxComponent,
    ArticoloInputComponent,
    ArticoloVarianteInputComponent,
    ArticoloGiacenzaComponent,
    ArticoloGiacenzaLottoComponent,
    ArticoloGiacenzaModalComponent,
    BilancaInputComponent,
    QuantitaInputComponent,
    BoxInputComponent,
    MagazzinoInputComponent,
    StatiScritturaInputComponent,
    UdmInputComponent,
    AnagraficaInputComponent,
    AnagraficaIndirizzoInputComponent,
    ArticoloCicloInputComponent,
    OrdineInputComponent,
    SpedizioneInputComponent,
    TimePickerInputComponent,
    ArticoloSchedeTecnicheComponent,
    SpedizioniLocaliListComponent,
    SpedizioniEsolverListComponent,
    SpedizioneLocaleItemComponent,
    SpedizioneEsolverItemComponent,
    SpedizioneUpdateSendComponent,
    SpedizioneEsolverLaunchComponent,
    SpedizioneSpostaColloComponent,
    SpedizioneStatoLabelComponent,
    DocumentoMagazzinoItemComponent,
    OrdineAllegatiComponent,
    ContenitoreTipoLabelComponent,
    ContenitoreLabelComponent,
    ContestoLabelComponent,
    CaratteristicaSchedaTecnicaComponent,
    DocumentoMagazzinoCreateComponent,
    DocumentoMagazzinoDetailComponent,
    DocumentoMagazzinoListComponent,
    DocumentoMagazzinoAddContenitoriComponent,
    SelezionaFaseContoLavoroModalComponent,
    DocumentoMagazzinoAddPrelievoComponent,
    FileUploadComponent,
    ImagePreviewComponent,
    TooltipDirective,
    MenuTriggerDirective,
    UdmConverterComponent,
    MovimentiRettificaComponent,
    AgentReportComponent,
    AgentChatComponent,
    AiChatPanelComponent,
    AiChatComandiComponent,
    AiChatArchivioComponent,
    QueuePendingOverlayComponent,
    ImportModalComponent,
    AnagraficaCreateComponent,
    PropagaOrdiniModalComponent,
    AllineaPianificaModalComponent,
    SelectAnagraficaRegistryComponent,
    ArticoliProdottiCreateComponent,
    PropagaOrdiniArticoloModalComponent,
    SelectArticoloProdottoComponent,
    CampiUtenteAccountComponent,
    OrdineVenditaCreateComponent,
    MaterialeOrdineCreateComponent,
    SelezionaPianificaModalComponent,
    ColorHexInputComponent,
    SelectAnagraficaSedeComponent,
    OrdiniVenditaShowColumnsComponent,
    OrdiniVenditaGroupColumnsComponent,
    OrdiniVenditaGroupbymanyComponent,
    OrdineVenditaRowComponent,
    OrdineVenditaCellsComponent,
    BadgeEnrollComponent,
    ScrollToTopComponent,
    PullToRefreshDirective,
  ],
  imports: [
    CommonModule,
    NgOptimizedImage,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    IonicModule.forRoot(),
    SelectModule,
    // Standalone components consumati internamente da componenti dichiarati qui.
    CampiUtenteFormComponent,
  ],
  exports: [
    FormsModule,
    SearchComponentComponent,
    OrdineStatoLabelComponent,
    InstallazioneTypeLabelComponent,
    TracciatiTypeFieldLabelComponent,
    TipoEventoLabelComponent,
    RisorsaTipoLabelComponent,
    OrdineEsolverItemComponent,
    OrdineEsolverGroupItemComponent,
    OrdineEsolverGroupLaunchComponent,
    OrdineLocalItemComponent,
    OrdiniFilterRowComponent,
    OrdineEsolverLaunchComponent,
    OrdineLocalCreateComponent,
    OrdineInfoComponent,
    OrdineSessioniComponent,
    OrdiniUpdateSendComponent,
    // Feature 151: elenco fasi a monte, in linea nella modale ordine e come modale nel Termina operatore.
    ChiudiFasiPrecedentiComponent,
    OrdiniEsolverComponent,
    OrdiniLocaliComponent,
    OrdiniLocaliGroupbymanyComponent,
    OrdiniViewmodeSwitchComponent,
    OrdineLocalGroupItemComponent,
    OrdineLocalGroupbymanyItemComponent,
    OrdiniEsolverGroupbymanyComponent,
    OrdineEsolverGroupbymanyItemComponent,
    OrdineLocalHeaderComponent,
    OrdiniLocaliListComponent,
    OrdiniGroupColumnsComponent,
    OrdiniShowColumnsComponent,
    OrdiniGroupUpdateSendComponent,
    TracciatiFieldCreateComponent,
    TracciatiFieldListComponent,
    TracciatiFieldRegoleComponent,
    TracciatoFieldStatoComponent,
    HubStateLedComponent,
    CentroNotificheComponent,
    CentroNotifichePopupComponent,
    OrdiniStatisticsComponent,
    QualitaStatisticsComponent,
    BarChartComponent,
    PieChartComponent,
    KeyboardComponent,
    EventiChartComponent,
    OrderByPipe,
    TruncatePipe,
    FloorPipe,
    TimeStringPipe,
    SumByPipe,
    SumByLengthPipe,
    UtcToLocalPipe,
    HighlightPipe,
    EnumLabelPipe,
    LicenzeConfigComponent,
    LicenzeConfigItemComponent,
    LicenzeMenuConfigComponent,
    OrdiniFilterRowCodiceUnivocoComponent,
    UserHeaderComponent,
    UserInfoComponent,
    FiltroOrdineComponent,
    MaterialeListComponent,
    MovimentoAddComponent,
    MovimentoTrasferimentoComponent,
    MovimentiCreateComponent,
    ContenitoriCreateComponent,
    LottoInputComponent,
    OptionComboboxComponent,
    ArticoloInputComponent,
    ArticoloVarianteInputComponent,
    ArticoloGiacenzaComponent,
    ArticoloGiacenzaLottoComponent,
    ArticoloGiacenzaModalComponent,
    SchedeQualitaListComponent,
    ControlloQualitaItemComponent,
    CheckControlliListComponent,
    ControlliQualitaOrdineComponent,
    BilancaInputComponent,
    QuantitaInputComponent,
    BoxInputComponent,
    MagazzinoInputComponent,
    StatiScritturaInputComponent,
    UdmInputComponent,
    AnagraficaInputComponent,
    AnagraficaIndirizzoInputComponent,
    ArticoloCicloInputComponent,
    OrdineInputComponent,
    SpedizioneInputComponent,
    TimePickerInputComponent,
    ArticoloSchedeTecnicheComponent,
    SpedizioniLocaliListComponent,
    SpedizioniEsolverListComponent,
    SpedizioneLocaleItemComponent,
    SpedizioneEsolverItemComponent,
    SpedizioneUpdateSendComponent,
    SpedizioneEsolverLaunchComponent,
    SpedizioneSpostaColloComponent,
    SpedizioneStatoLabelComponent,
    DocumentoMagazzinoItemComponent,
    OrdineAllegatiComponent,
    ContenitoreTipoLabelComponent,
    ContenitoreLabelComponent,
    ContestoLabelComponent,
    CaratteristicaSchedaTecnicaComponent,
    DocumentoMagazzinoCreateComponent,
    DocumentoMagazzinoDetailComponent,
    DocumentoMagazzinoListComponent,
    DocumentoMagazzinoAddContenitoriComponent,
    SelezionaFaseContoLavoroModalComponent,
    DocumentoMagazzinoAddPrelievoComponent,
    FileUploadComponent,
    ImagePreviewComponent,
    TooltipDirective,
    MenuTriggerDirective,
    UdmConverterComponent,
    MovimentiRettificaComponent,
    AgentReportComponent,
    AgentChatComponent,
    AiChatPanelComponent,
    AiChatComandiComponent,
    AiChatArchivioComponent,
    QueuePendingOverlayComponent,
    ImportModalComponent,
    AnagraficaCreateComponent,
    PropagaOrdiniModalComponent,
    AllineaPianificaModalComponent,
    SelectAnagraficaRegistryComponent,
    ArticoliProdottiCreateComponent,
    PropagaOrdiniArticoloModalComponent,
    SelectArticoloProdottoComponent,
    CampiUtenteAccountComponent,
    OrdineVenditaCreateComponent,
    MaterialeOrdineCreateComponent,
    SelezionaPianificaModalComponent,
    ColorHexInputComponent,
    SelectAnagraficaSedeComponent,
    OrdiniVenditaShowColumnsComponent,
    OrdiniVenditaGroupColumnsComponent,
    OrdiniVenditaGroupbymanyComponent,
    OrdineVenditaRowComponent,
    OrdineVenditaCellsComponent,
    BadgeEnrollComponent,
    ScrollToTopComponent,
    PullToRefreshDirective,
    IonicModule
  ],
  providers: []
})
export class SharedModule {
}
